import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    path?: string;
    noindex?: boolean;
}

const SITE_NAME = 'Chamba';
const BASE_URL = 'https://chamba.app';
const DEFAULT_DESCRIPTION = 'Plataforma de trabajos freelance que conecta profesionales con oportunidades verificadas.';

export function SEO({ title, description = DEFAULT_DESCRIPTION, path = '', noindex }: SEOProps) {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Plataforma de Trabajos Freelance`;
    const url = `${BASE_URL}${path}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />

            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />

            {noindex && <meta name="robots" content="noindex, nofollow" />}
        </Helmet>
    );
}
